import { render, staticRenderFns } from "./CRUDEquipamentos.vue?vue&type=template&id=08a11f36&scoped=true&"
import script from "./CRUDEquipamentos.vue?vue&type=script&lang=js&"
export * from "./CRUDEquipamentos.vue?vue&type=script&lang=js&"
import style0 from "./CRUDEquipamentos.vue?vue&type=style&index=0&id=08a11f36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a11f36",
  null
  
)

export default component.exports